import { render, staticRenderFns } from "./ButtonsPanelComponent.vue?vue&type=template&id=00f11850&scoped=true&"
import script from "./ButtonsPanelComponent.vue?vue&type=script&lang=ts&"
export * from "./ButtonsPanelComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f11850",
  null
  
)

export default component.exports